import { configureStore } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import { combineReducers } from 'redux';
import thunk from 'redux-thunk';
import storage from 'redux-persist/lib/storage'; //
import playerReducer from './features/playerSlice';
import stationReducer from './features/stationSlice';
import adminReducer from './features/adminSlice';

const reducers = combineReducers({
  player: playerReducer,
  stations: stationReducer,
  admin: adminReducer,
});

const persistConfig = {
  key: 'root',
  storage,
};

const persistentReducer = persistReducer(persistConfig, reducers);

export default configureStore({
  reducer: persistentReducer,
  middleware: [thunk],
});
